/**
 * PillarsStrip — three-pillar service positioning card row.
 * Mirrors the hero slider of live www.texcheme.com:
 *   Storage Facilities · Pan-India Chemical Supply · Robust Logistics Network
 */
import { motion } from "framer-motion";
import { Warehouse, Truck, Route } from "lucide-react";
import { staggerContainer, staggerItem } from "./PageTransition";

const ICONS = {
  storage: Warehouse,
  supply: Truck,
  logistics: Route,
};

export default function PillarsStrip({ pillars = [], onCta }) {
  if (!pillars.length) return null;
  return (
    <section className="section-lg pillars-section" data-testid="pillars-strip">
      <div className="wrap">
        <div className="section-eyebrow" data-testid="pillars-eyebrow">
          What we do
        </div>
        <motion.div
          className="pillars-grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {pillars.map((p) => {
            const Icon = ICONS[p.key] || Truck;
            return (
              <motion.article
                key={p.key}
                className="pillar-card"
                variants={staggerItem}
                data-testid={`pillar-${p.key}`}
              >
                <div className="pillar-icon" aria-hidden="true">
                  <Icon size={22} strokeWidth={2} />
                </div>
                <div className="pillar-kicker">{p.kicker}</div>
                <h3 className="pillar-title">{p.title}</h3>
                <p className="pillar-body">{p.body}</p>
                <button
                  className="btn-link"
                  onClick={() => onCta && onCta(p.key)}
                  data-testid={`pillar-cta-${p.key}`}
                >
                  Request a quote →
                </button>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
